import React from 'react'
import { Typography, Container } from '@material-ui/core'

export const Outputs = () => {
  return (
    <Container>
      <Typography>Output Details Coming Soon!</Typography>
    </Container>
  )
}
